import { Box, Grid, TextField, Typography } from "@mui/material";
import Logger from "../../../services/Logger";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import validator from "validator";
import CustomButton from "../../components/CustomButton";
import RetrieveNews from "./RetrieveNews";
import TopicService from "./TopicService";

export default function TopicCreate() {
    const navigate = useNavigate();
    const [title, setTitle] = useState("");
    const [relatedWords, setRelatedWords] = useState("");
    const [extractionText, setExtractionText] = useState("");

    const [errTitle, setErrTitle] = useState(false);
    const [errRelatedWords, setErrRelatedWords] = useState(false);

    useEffect(() => {
        // Add any additional logic you want to run on mount
    }, []);


    const handleCreateTopic = () => {
        if (validator.isEmpty(title)) {
            setErrTitle(true);
            return;
        }
        setErrTitle(false);

        if (validator.isEmpty(relatedWords)) {
            setErrRelatedWords(true);
            return;
        }
        setErrRelatedWords(false);

        TopicService.createTopic(title, relatedWords).then(() => {
            navigate("/admin/topic");
        });
    };

    const handleExtract = (title, result) => {
        Logger.log(title, result);

        let temp = []
        
        // Handle adjectives
        if (result?.adjectives) {
            Object.values(result.adjectives).forEach(adjective => {
                if (adjective.category !== "COMMON") {
                    temp.push(adjective.word);
                }
            });
        }
        
        // Handle nouns
        if (result?.nouns) {
            Object.values(result.nouns).forEach(noun => {
                if (noun.category !== "COMMON") {
                    temp.push(noun.word);
                }
            });
        }
        
        // Handle verbs
        if (result?.verbs) {
            Object.values(result.verbs).forEach(verb => {
                if (verb.category !== "COMMON") {
                    temp.push(verb.word);
                }
            });
        }

        setRelatedWords(temp.join("\n"));        
        setTitle(title);
    };

    return (
        <Box>
            <Grid container spacing={3}>
                {/* Left Column - Create Topic Form */}
                <Grid size={{ xs: 6 }}>
                    <Box maxWidth={"sm"}>
                        <Grid container>
                            <Grid size={{ xs: 12 }}>
                                <TextField
                                    label="Title"
                                    variant="outlined"
                                    fullWidth
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    margin="normal"
                                    error={errTitle}
                                />
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <TextField
                                    label="Related Words"
                                    multiline
                                    rows={12}
                                    variant="outlined"
                                    fullWidth
                                    value={relatedWords}
                                    onChange={(e) => setRelatedWords(e.target.value)}
                                    margin="normal"
                                    error={errRelatedWords}
                                />
                            </Grid>
                            <Grid size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography variant="body1" color="text.secondary">
                                    {relatedWords.split('\n').filter(word => word.trim() !== '').length} words
                                </Typography>
                                <CustomButton variant="contained" title="Create" onClick={handleCreateTopic}>
                                    Create
                                </CustomButton>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                
                {/* Right Column - News Search */}
                <Grid size={{ xs: 6 }}>
                    <RetrieveNews onExtract={handleExtract} />
                </Grid>
            </Grid>
        </Box>
    );
}
